import { SortingState } from '@tanstack/react-table';
import { TransactionType } from '@repo/common-types';

export enum TableTransactionsActionType {
  SET_FILTERS = 'SET_FILTERS',
  SET_SEARCH = 'SET_SEARCH',
  SET_USER_ID = 'SET_USER_ID',
  SET_TYPE = 'SET_TYPE',
  SET_PAGINATION = 'SET_PAGINATION',
  SET_SORTING = 'SET_SORTING',
  RESET_FILTERS = 'RESET_FILTERS',
}

export interface TableTransactionsFilter {
  search?: string;
  userId?: string;
  type?: TransactionType;
}

export type TableTransactionsAction =
  | { type: TableTransactionsActionType.SET_FILTERS; payload: TableTransactionsFilter }
  | { type: TableTransactionsActionType.SET_SEARCH; payload: string }
  | { type: TableTransactionsActionType.SET_USER_ID; payload: string }
  | { type: TableTransactionsActionType.SET_TYPE; payload: TransactionType }
  | { type: TableTransactionsActionType.SET_PAGINATION; payload: { skip: number; take: number } }
  | { type: TableTransactionsActionType.SET_SORTING; payload: SortingState }
  | { type: TableTransactionsActionType.RESET_FILTERS };

export interface TableTransactionsQueryState {
  filter: TableTransactionsFilter;
  skip: number;
  take: number;
  sorting: SortingState;
}

export const initialFilters: TableTransactionsFilter = {
  search: undefined,
  userId: undefined,
  type: undefined,
};

export const initialState: TableTransactionsQueryState = {
  filter: initialFilters,
  skip: 0,
  take: 15,
  sorting: [
    {
      id: 'createdAt',
      desc: true,
    },
  ],
};

export const tableTransactionsQueryReducer = (
  state: TableTransactionsQueryState,
  action: TableTransactionsAction,
): TableTransactionsQueryState => {
  switch (action.type) {
    case TableTransactionsActionType.SET_FILTERS:
      return {
        ...state,
        filter: action.payload,
        skip: 0,
      };
    case TableTransactionsActionType.SET_SEARCH:
      return {
        ...state,
        filter: { ...state.filter, search: action.payload },
        skip: 0,
      };
    case TableTransactionsActionType.SET_USER_ID:
      return {
        ...state,
        filter: { ...state.filter, userId: action.payload },
        skip: 0,
      };
    case TableTransactionsActionType.SET_TYPE:
      return {
        ...state,
        filter: { ...state.filter, type: action.payload },
        skip: 0,
      };
    case TableTransactionsActionType.SET_PAGINATION:
      return {
        ...state,
        skip: action.payload.skip,
        take: action.payload.take,
      };
    case TableTransactionsActionType.SET_SORTING:
      return {
        ...state,
        sorting: action.payload,
        skip: 0,
      };
    case TableTransactionsActionType.RESET_FILTERS:
      return initialState;
    default:
      return state;
  }
};
